/*

--------------------------------------------------------------------------------
Oriflame extension for Kendo grid
--------------------------------------------------------------------------------

*/

; (function ($) {

    "use strict";

    var kendo = window.kendo;
    if (!kendo) return;
    var Grid = kendo.ui.Grid;
    if (!Grid || Grid.updated) return;

    var NS = ".kendoGrid",
        gridPrototype = Grid.prototype,
        oldGridInit = Grid.fn.init,
        outerHeight = kendo._outerHeight,
        // hot tracking functionality
        DATA_ITEM_URL = "row-url",
        HOT_TRACKING_CLASS = "k-grid-hot-tracking",
        FOCUSED_STATE_CLASS = "k-state-focused";

    /**
     * Temporary override for the new FE scripts to work also with outdated BE helpers.
     * TODO: Once all initializations are done wihtout BE helpers, remove this.
     */
    function newInit(element, options) {
        var $element = $(element),
            classReplacements = [
                { from: "k-i-seek-w", to: "k-i-arrow-end-left" },
                { from: "k-i-arrow-w", to: "k-i-arrow-60-left" },
                { from: "k-i-arrow-e", to: "k-i-arrow-60-right" },
                { from: "k-i-seek-e", to: "k-i-arrow-end-right" },
            ];
        // update markup if old BE helper generated it
        classReplacements.forEach(function (item) {
            $element.find("." + item.from).addClass(item.to).removeClass(item.from);
        });
        oldGridInit.call(this, element, options);
    }

    function gridApplyFilter(fieldName, filterValue, filterOperator, filtersLogic) {
        // get currently applied filters from the Grid.
        var currFilterObj = this.dataSource.filter();

        // get current set of filters, which is supposed to be array.
        // if the object we obtained above is null/undefined, set this to an empty array
        var currentFilters = currFilterObj ? currFilterObj.filters : [];

        // iterate over current filters array. if a filter for "fieldName" is already
        // defined, remove it from the array
        // once an entry is removed, we stop looking at the rest of the array.
        if (currentFilters && currentFilters.length) {
            for (var i = 0; i < currentFilters.length; i++) {
                if (currentFilters[i].field === fieldName) {
                    currentFilters.splice(i, 1);
                    break;
                }
            }
        }

        // if filterValue is not empty, add the filter to currentFilters
        if (filterValue) {
            currentFilters.push({ field: fieldName, operator: filterOperator, value: filterValue });
        }

        this.dataSource.filter({ logic: filtersLogic, filters: currentFilters });
    };

    function gridEnableHotTracking() {
        var self = this,
            $tbody = $(self.tbody);
        $(self.element).addClass(HOT_TRACKING_CLASS);
        // remove focus CSS class when a cell in a row is clicked
        $tbody.on("click" + NS, "td", function () {
            $(this).removeClass(FOCUSED_STATE_CLASS);
        });
        gridBindRowClick.apply(self);
    }

    function gridBindRowClick() {
        var self = this,
            $tbody = $(self.tbody),
            $rows = $("tr", $tbody);

        // remember link for whole row, remove link tag and leave out its content
        $rows.each(function () {
            var $link = $(this).find("a:first");
            if (!$link || !$link.length) return;
            var href = $link.attr("href");
            if (!href) return;
            $(this).data(DATA_ITEM_URL, href);
            $link.after($link.html()).remove();
        });

        // redirect when row is clicked
        $tbody.on("click" + NS, "tr", function () {
            var url = $(this).data(DATA_ITEM_URL);
            if (url) {
                window.location.href = url;
            }
        });
    };

    function setContentHeight() {
        var self = this,
            options = self.options,
            height = self.wrapper.innerHeight(),
            header = self.wrapper.children(".k-grid-header"),
            scrollbar = kendo.support.scrollbar();
        var scrollableHeight = (options.scrollable || {}).height;

        if (options.scrollable && self.wrapper.is(":visible")) {

            height -= outerHeight(header);

            if (self.pager && self.pager.element.is(":visible")) {
                height -= outerHeight(self.pager.element);
            }

            if (options.groupable) {
                height -= outerHeight(self.wrapper.children(".k-grouping-header"));
            }

            if (options.toolbar) {
                height -= outerHeight(self.wrapper.children(".k-grid-toolbar"));
            }

            if (self.footerTemplate) {
                height -= outerHeight(self.wrapper.children(".k-grid-footer"));
            }

            var isGridHeightSet = function (el) {
                var initialHeight, newHeight;
                if (el[0].style.height) {
                    return true;
                }

                initialHeight = el.height();
                el.height("auto");
                newHeight = el.height();

                if (initialHeight != newHeight) {
                    el.height("");
                    return true;
                }
                el.height("");
                return false;
            };

            if (isGridHeightSet(self.wrapper)) { // set content height only if needed
                if (height > scrollbar * 2) { // do not set height if proper scrollbar cannot be displayed
                    if (self.lockedContent) {
                        scrollbar = self.table[0].offsetWidth > self.table.parent()[0].clientWidth ? scrollbar : 0;
                        self.lockedContent.height(height - scrollbar);
                    }

                    self.content.height(height);
                } else {
                    self.content.height(scrollbar * 2 + 1);
                }
            } else if (scrollableHeight && scrollableHeight !== "auto") { // this line is changed by Oriflame
                //fallback to client-side setting as MVC Core wrapper does not provide server rendering of the content
                self.content.css("height", scrollableHeight);
            }
        }
    }

    Grid = Grid.extend({
        // updated "constructor"
        init: newInit,
        // updated methods
        applyFilter: gridApplyFilter,
        enableHotTracking: gridEnableHotTracking,
        bindRowClick: gridBindRowClick,
        hasChanges: function () {
            var self = this;
            return self.dataSource ? self.dataSource.hasChanges() : false;
        },
        _setContentHeight: setContentHeight
    });

    Grid.updated = true;

    kendo.ui.plugin(Grid);

})(window.kendo.jQuery);
